import { AgTechOperationApplicationStatus } from "@agtech/core/data/AgTechOperationData";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";
import { ProductDTO } from "@agtech/data/operations/OperationData";
import { DocumentHeaderConfiguration, InvoiceDocumentConfiguration } from "./SaleDataOperation";

export const SaleOperationDataGetRegistrationStatusQuery: AgTechQuery<any, AgTechOperationApplicationStatus> = {
    queryKey: () => ['OperationStatus'],
    query: (props) => {
        return props.http.getEntity<AgTechOperationApplicationStatus>({
            request: 'Operation/Status'
        });
    },
    content: {
        loadingText: 'Loading registration...',
        failureText: 'Failed to load registration'
    }
}

export const SaleOperationDataGetLicensedProductsQuery: AgTechQuery<any, ProductDTO[]> = {
    queryKey: () => ['OperationLicenses'],
    query: (props) => {
        return props.http.getEntity<ProductDTO[]>({
            request: 'Operation/Licensing/Products'
        });
    },
    content: {
        loadingText: 'Loading products...',
        failureText: 'Failed to load products'
    }
}

export const SaleOperationDataGetDocumentHeaderConfigurationQuery: AgTechQuery<any, DocumentHeaderConfiguration> = {
    queryKey: () => ['DocumentHeader'],
    query: (props) => {
        return props.http.getEntity<DocumentHeaderConfiguration>({
            request: 'Operation/Settings/DocumentHeaderConfiguration'
        });
    },
    content: {
        loadingText: 'Loading document header...',
        failureText: 'Failed to load document header'
    }
}

export const SaleOperationDataGetInvoiceDocumentHeaderConfigurationQuery: AgTechQuery<any, InvoiceDocumentConfiguration> = {
    queryKey: () => ['InvoiceDocumentHeader'],
    query: (props) => {
        return props.http.getEntity<InvoiceDocumentConfiguration>({
            request: 'Operation/Settings/InvoiceDocumentConfiguration'
        });
    },
    content: {
        loadingText: 'Loading invoice document header...',
        failureText: 'Failed to load invoice document header'
    }
}